// @flow
// Libs
import React from 'react'

// Components
import SelectWithRange from './SelectWithRange'

// Constants
import { SIZE_TOOL_CONFIG } from '../../constants'

// Styles
const styles = {
  container: {
    marginRight: '30px',
  },
}

// Types
type Props = {
  operation: Object,
  selectedFeatureIndices: Array<number>,
  onChange: Function,
}

export default function ScaleGrid (props: Props): React.Element<any> {
  return <SelectWithRange {...props} config={SIZE_TOOL_CONFIG} styles={styles} stylingClasses='select-map-grid-tool' />
}
